module.exports = __webpack_public_path__ + "static/media/logo-mask.8caae2a6.png";